import { useEffect, useState } from "react";
import moment from 'moment';
import 'moment/locale/es';
import { useParams } from "react-router-dom";
import axios from 'axios';
import './News.css';
import { Helmet } from 'react-helmet';
import logo from '../../assets/images/logo_radioital_blanco.png';
import SocialShare from "./SocialShare";

function getDia(num) {
  let meses = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado" ];
  return meses[num];
}

const News = () => {
  const id = useParams();
  const API_URL = 'https://radioital.com/api/public/api/noticia/' + id.id;
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    //datos del programa
    axios.get(API_URL, {
      headers: {
        //'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer token' // si lo usas
      }
    })
      .then(function(res){
        setData(res.data.data);
      });

  }, []);

  if (data) {
    return (<>
      <Helmet>
        <title>{data.titulo_ntca} | Nota Ital</title>
        <meta property="og:title" content={data.titulo_ntca} />
        <meta property="og:description" content={data.dscrpcncrta_ntca.slice(0, 150)} />
        <meta property="og:image" content="https://radioital.com/static/media/logo.png" />
        <meta property="og:url" content={"https://radioital.com/news/"+data.key_ntca} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={data.titulo_ntca} />
        <meta name="twitter:description" content={data.dscrpcncrta_ntca.slice(0, 150)} />
        <meta name="twitter:image" content="https://radioital.com/static/media/logo.png" />
      </Helmet>
      <div className="post">
        <div className="post_body">
          <div className="news_body_left">
            <img src={"../news/" + data.imgn_ntca} alt={data.titulo_ntca} className="show-image" />
            <h1>{data.titulo_ntca}</h1>
            <h3>Autor: {data.autor_ntca}</h3>
          </div>
          <div className="news_body_right">
            <p dangerouslySetInnerHTML={{ __html: data.cntnd_ntca }}></p>
          </div>
        </div>
        <div className="socialshare">
          <SocialShare
              title={data.titulo_ntca}
              url={"https://radioital.com/news/"+data.key_ntca}
            />
        </div>
      </div>
      </>
    )
  }else{
    <div className="post">
        <div className="post_body">
          <h2>Estamos preparando la nota...</h2>
        </div>
    </div>
  }
};

export default News;